import PartyTarget from "../../../../model/character/PartyTarget";
import Damage from "../../../../model/crew/Damage";
import BigNum from "../../../../model/math/BigNum";
import Values from "../../../../model/value/Values";
import Page from "../../../framework/Page";
import ParentView from "../../../framework/ParentView";
import View from "../../../framework/View";
import { PageIds } from "../../../PageIds";
import BaseDamagePerSecondView from "./BaseDamagePerSecondView";
import DepthDamageView from "./DepthDamageView";
import GoldDamageView from "./GoldDamageView";
import MineDamageLabelView from "./MineDamageLabelView";
import MultiplierOreView from "./MultiplierOreView";
import RubyDamageView from "./RubyDamageView";
import OperatorView from "./OperatorView";
import PrestigeDamageView from "./PrestigeDamageView";
import TotalDamageView from "./TotalDamageView";
import MinedDamageView from "./MinedDamageView";
import BlocksDamageView from "./BlocksDamageView";

export default class MineDamageView extends ParentView {
    /**
     * @param {string} parentId
     * @param {Damage} damage
     * @param {Values} values
     * @param {PartyTarget} partyTarget
     */
    constructor(parentId, damage, values, partyTarget) {
        super(parentId, PageIds.MINE_DAMAGE_VIEW);

        /**
         * @constant
         * @type {BigNum}
         */
        this.one = new BigNum(1);
        /**
         * @constant
         * @type {Damage}
         */
        this.damage = damage;

        /**
         * @type {boolean}
         */
        this.minedDamageVisible = false;
        /**
         * @type {boolean}
         */
        this.prestigeDamageVisible = false;
        /**
         * @type {boolean}
         */
        this.goldDamageVisible = false;
        /**
         * @type {boolean}
         */
        this.depthDamageVisible = false;
        /**
         * @type {boolean}
         */
        this.rubyDamageVisible = false;
        /**
         * @type {boolean}
         */
        this.blocksDamageVisible = false;


        this.addView(new MineDamageLabelView(this.elementId));

        this.addView(new BaseDamagePerSecondView(this.elementId, damage, values));

        this.addView(new OperatorView(this.elementId, this.elementId + '3', ' x '));
        
        this.addView(new MultiplierOreView(this.elementId, damage));

        //////////////////////////////////////////
        // Conditionally Visible: MINED DAMAGE
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.minedDamageOperator = new OperatorView(this.elementId, this.elementId + '6', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.minedDamageView = new MinedDamageView(this.elementId, damage);

        this.addView(this.minedDamageOperator);
        this.addView(this.minedDamageView);

        this.minedDamageOperator.setInitialVisibility(false);
        this.minedDamageView.setInitialVisibility(false);

        //////////////////////////////////////////
        // Conditionally Visible: PRESTIGE
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.prestigeOperator = new OperatorView(this.elementId, this.elementId + '7', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.prestigeDamageView = new PrestigeDamageView(this.elementId, damage);

        this.addView(this.prestigeOperator);
        this.addView(this.prestigeDamageView);

        this.prestigeOperator.setInitialVisibility(false);
        this.prestigeDamageView.setInitialVisibility(false);

        //////////////////////////////////////////
        // Conditionally Visible: GOLD
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.goldOperator = new OperatorView(this.elementId, this.elementId + '8', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.goldDamageView = new GoldDamageView(this.elementId, damage);

        this.addView(this.goldOperator);
        this.addView(this.goldDamageView);

        this.goldOperator.setInitialVisibility(false);
        this.goldDamageView.setInitialVisibility(false);

        //////////////////////////////////////////
        // Conditionally Visible: DEPTH
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.depthOperator = new OperatorView(this.elementId, this.elementId + '9', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.depthDamageView = new DepthDamageView(this.elementId, damage);

        this.addView(this.depthOperator);
        this.addView(this.depthDamageView);

        this.depthOperator.setInitialVisibility(false);
        this.depthDamageView.setInitialVisibility(false);


        //////////////////////////////////////////
        // Conditionally Visible: RUBY
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.rubyOperator = new OperatorView(this.elementId, this.elementId + '10', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.rubyDamageView = new RubyDamageView(this.elementId, damage);

        this.addView(this.rubyOperator);
        this.addView(this.rubyDamageView);

        this.rubyOperator.setInitialVisibility(false);
        this.rubyDamageView.setInitialVisibility(false);


        //////////////////////////////////////////
        // Conditionally Visible: BLOCKS
        //////////////////////////////////////////

        /**
         * @constant
         * @type {OperatorView}
         */
        this.blocksOperator = new OperatorView(this.elementId, this.elementId + '11', ' x ');
        /**
         * @constant
         * @type {View}
         */
        this.blocksDamageView = new BlocksDamageView(this.elementId, damage);

        this.addView(this.blocksOperator);
        this.addView(this.blocksDamageView);

        this.blocksOperator.setInitialVisibility(false);
        this.blocksDamageView.setInitialVisibility(false);

        //////////////////////////////////////////
        // TOTAL DAMAGE
        //////////////////////////////////////////

        this.addView(new OperatorView(this.elementId, this.elementId + '12', ' = '));
        this.addView(new TotalDamageView(this.elementId, damage));

        // //////////////////////////////////////////
        // // TARGET DEPTH
        // //////////////////////////////////////////

        // this.addView(new OperatorView(this.elementId, this.elementId + '11', ' \u2234 '));
        // this.addView(new TargetDepthView(this.elementId, partyTarget));

        this.setInitialVisibility(true);
    }

    /**
     * @override
     */
    initializeView() {

        // <span id="mineDamageDisplay" class="mine-damage-display"></span>

        const parentElement = Page.getElement(this.parentId);
        Page.createElement('div', parentElement, this.getElementId(), 'mine-damage-panel');

        super.initializeView();        
    }

    /**
     * @override
     */
    updateView() {

        const minedDamageVisible = this.damage.minedDamageMultiplier.greaterThan(this.one);
        const prestigeDamageVisible = this.damage.prestigeDamageMultiplier.greaterThan(this.one);
        const goldDamageVisible = this.damage.goldDamageMultiplier.greaterThan(this.one);
        const depthDamageVisible = this.damage.depthDamageMultiplier.greaterThan(this.one);
        const rubyDamageVisible = this.damage.rubyDamageMultiplier.greaterThan(this.one);
        const blocksDamageVisible = this.damage.blockDamageMultiplier.greaterThan(this.one);

        if (this.minedDamageVisible !== minedDamageVisible) {
            this.minedDamageVisible = minedDamageVisible;

            this.minedDamageOperator.setViewVisible(minedDamageVisible);
            this.minedDamageView.setViewVisible(minedDamageVisible);
        }

        if (this.prestigeDamageVisible !== prestigeDamageVisible) {
            this.prestigeDamageVisible = prestigeDamageVisible;

            this.prestigeOperator.setViewVisible(prestigeDamageVisible);
            this.prestigeDamageView.setViewVisible(prestigeDamageVisible);
        }

        if (this.goldDamageVisible !== goldDamageVisible) {
            this.goldDamageVisible = goldDamageVisible;

            this.goldOperator.setViewVisible(goldDamageVisible);
            this.goldDamageView.setViewVisible(goldDamageVisible);
        }

        if (this.depthDamageVisible !== depthDamageVisible) {
            this.depthDamageVisible = depthDamageVisible;

            this.depthOperator.setViewVisible(depthDamageVisible);
            this.depthDamageView.setViewVisible(depthDamageVisible);
        }

        if (this.rubyDamageVisible !== rubyDamageVisible) {
            this.rubyDamageVisible = rubyDamageVisible;

            this.rubyOperator.setViewVisible(rubyDamageVisible);
            this.rubyDamageView.setViewVisible(rubyDamageVisible);
        }

        if (this.blocksDamageVisible !== blocksDamageVisible) {
            this.blocksDamageVisible = blocksDamageVisible;

            this.blocksOperator.setViewVisible(blocksDamageVisible);
            this.blocksDamageView.setViewVisible(blocksDamageVisible);
        }

        super.updateView();
    }

    /**
     * @override
     * @returns {string}
     */
    getVisibileDisplayValue() {
        return 'inline-block'; // This is a span element.  Don't use display:block.
    }

}